export const GENERAL_FAQS = [
  {
    q: "What is HerbKranti's philosophy?",
    a: "HerbKranti is a premium Indian wellness brand built on considered sourcing, transparent labelling and modern presentation. We look to India's Ayurvedic tradition as a living library, not folklore — and we adapt it thoughtfully for modern daily life.",
  },
  {
    q: "Are HerbKranti products certified?",
    a: "Every launched product is manufactured in FSSAI-registered facilities and produced with published batch quality checks. Product-specific certifications are detailed on each product page and published at launch for upcoming products.",
  },
  {
    q: "Do you ship pan-India?",
    a: "Yes — we deliver across India via trusted courier partners. Orders are typically dispatched within 24-48 hours of confirmation, and delivery timelines depend on your pincode.",
  },
  {
    q: "What is your return / refund policy?",
    a: "For hygiene and product-integrity reasons, HerbKranti products cannot be returned once the seal is opened. If your package arrives damaged, tampered with or with a broken seal, please refuse delivery and contact our team within 24 hours. See the full Refund & Return Policy for details.",
  },
  {
    q: "How can I track my order?",
    a: "Once your order is dispatched, you'll receive tracking details via WhatsApp and email. You can also reach out to us anytime for updates.",
  },
  {
    q: "Do you offer Cash on Delivery?",
    a: "No. HerbKranti accepts prepaid orders only — UPI, credit/debit card, net banking and supported wallets via our secure Razorpay gateway. This ensures faster processing and secure order confirmation.",
  },
  {
    q: "Are HerbKranti products safe during pregnancy or with prescribed medication?",
    a: "Our products are foods, not medicines. If you are pregnant, nursing or on prescribed medication, we recommend consulting your physician before adding any new product to your daily routine.",
  },
  {
    q: "How do I place a bulk / corporate order?",
    a: "For bulk enquiries, gifting hampers and corporate wellness partnerships, please email herbkranti@gmail.com or WhatsApp us at +91 72497 97972.",
  },
];
